export const PROCESS_FIELD_ERROR = "PROCESS_FIELD_ERROR";
export const VERIFY_FORM_VALIDITY = "VERIFY_FORM_VALIDITY";
